export class XmfhChannel {
    id: number;
    fiberId: number;
    pairedFiberId?: number;
    itu: number;
    frequency: number;
    wavelength: number;
    channelPower: number;
    name?: string;
    fqdn?: string;
    daasName?: string;
    daasPort?: string;
    description?: string;
    lastPowerTimestamp?: number;
    lastLightTimestamp?: number;
    lastDarkTimestamp?: number;
    createdTimestamp: number;
    updatedTimestamp: number;
    litCount?: number;
    nodeDesignDistance?: number;
    nodeGisDistance?: number;
    lit: boolean;
    lastCheckinTimestamp?: number;

    get power(): number { return this.channelPower; }

    set power(value: number) { this.channelPower = value; }

    get channelId(): number { return this.id; }
}
